import { Box, BoxProps, Card, Heading, Text } from "@vinomofo/components";

import type { PropsWithChildren } from "react";

export interface AccountCardProps extends BoxProps {
  heading?: string;
  description?: string;
}

export const AccountCard = ({
  heading,
  description,
  children,
  ...rest
}: PropsWithChildren<AccountCardProps>): JSX.Element => {
  return (
    <Card backgroundColor="white" alignItems="flex-start" {...rest}>
      <Box width="100%">
        {heading && (
          <Box
            py={30}
            px={[20, 40]}
            borderBottom="1px solid"
            borderBottomColor="divider"
          >
            <Heading as="h3" variant="xs">
              {heading}
            </Heading>
            {description && <Text variant="sm">{description}</Text>}
          </Box>
        )}

        {children}
      </Box>
    </Card>
  );
};
